import { useEffect, useState } from "react";
import api from "../../../../../../../services/api";
import { IItemHistorico } from "../../../../types";
import { ExpandedContent as ExpandedContainer, Separator } from "./styles";
import { DadosOrientacaoCompleta } from "./types";
import { mapearCamposOrientacaoCompleta } from "./utils";
import { mapearAnexosOrientacaoCompleta } from "../OrientacaoCompletaCriada/utils";
import BlocoOrientacaoCompleta from "./Blocos/BlocoOrientacaoCompleta";
import BlocoAnexos from "../OrientacaoCompletaCriada/Blocos/BlocoAnexos";
import LogsVazio from "../../Compartilhado/LogsVazio";

interface ExpandedContentProps {
    item: IItemHistorico;
    onNavigateToFile?: (fileId: number) => void;
}

export default function ExpandedContentOrientacaoCompletaEditada({ item, onNavigateToFile }: ExpandedContentProps) {
    const [dados, setDados] = useState<DadosOrientacaoCompleta | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!item?.id) {
            setLoading(false);
            setDados(null);
            return;
        }

        let cancelado = false;

        const carregarDados = async () => {
            setLoading(true);

            try {
                const resposta = await api.get(`log-historico/${item.id}`);
                
                if (cancelado) {
                    return;
                }

                if (resposta.data.status === "success") {
                    const logs = resposta.data.result || [];
                    const logOrientacao = logs.find((log: any) => log.entidade_nome === "orientacao");
                    const campos = logOrientacao ? mapearCamposOrientacaoCompleta(logOrientacao.dados_antes, logOrientacao.dados_depois) : [];
                    const anexos = mapearAnexosOrientacaoCompleta(logs);

                    if (!cancelado) {
                        setDados({
                            campos,
                            anexos
                        });
                    }
                } else {
                    if (!cancelado) {
                        setDados(null);
                    }
                }
            } catch (_erro) {
                if (!cancelado) {
                    setDados(null);
                }
            } finally {
                if (!cancelado) {
                    setLoading(false);
                }
            }
        };

        carregarDados();

        return () => {
            cancelado = true;
        };
    }, [item.id]);

    if (loading) {
        return (
            <ExpandedContainer>
                <div style={{ padding: "20px", textAlign: "center", color: "var(--c64748b)" }}>
                    Carregando dados...
                </div>
            </ExpandedContainer>
        );
    }

    const temCampos = dados?.campos && dados.campos.length > 0;
    const temAnexos = dados?.anexos && dados.anexos.length > 0;
    const semDados = !dados || (!temCampos && !temAnexos);

    if (semDados) {
        return (
            <ExpandedContainer>
                <Separator />
                <LogsVazio />
            </ExpandedContainer>
        );
    }

    return (
        <ExpandedContainer>
            <Separator />
            {dados.campos && dados.campos.length > 0 && <BlocoOrientacaoCompleta campos={dados.campos} />}
            {dados.anexos && dados.anexos.length > 0 && <BlocoAnexos anexos={dados.anexos} onNavigateToFile={onNavigateToFile} />}
        </ExpandedContainer>
    );
}


